var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"id":"register-myinfo-callback-page","name":"register-myinfo-callback-page"},on:{"page:beforein":function($event){return _vm.init()},"page:afterin":_vm.afterin}},[_c('f7-block')],1)}
var staticRenderFns = []

export { render, staticRenderFns }